import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['headerCheckbox', 'checkbox'];

  updateTableCheckboxes () {
    const { checked } = this.headerCheckboxTarget;

    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = checked;
    });
    this.updateDownloadAdmissionsButton();
  }

  updateHeaderCheckbox () {
    if (this.hasHeaderCheckboxTarget) {
      const checkedCount = Array.from(this.checkboxTargets)
        .filter(checkbox => checkbox.checked).length;
      if (checkedCount === 0) {
        this.headerCheckboxTarget.checked = false;
        this.headerCheckboxTarget.indeterminate = false;
      } else if (this.checkboxTargets.length === checkedCount) {
        this.headerCheckboxTarget.checked = true;
        this.headerCheckboxTarget.indeterminate = false;
      } else {
        this.headerCheckboxTarget.checked = false;
        this.headerCheckboxTarget.indeterminate = true;
      }
    }
    this.updateDownloadAdmissionsButton();
  }

  updateDownloadAdmissionsButton () {
    const downloadCsv = document.getElementById('downloadAdmissions');
    const admissionIds = [];
    const admissionSelected = Array.from(this.checkboxTargets).filter(checkbox => checkbox.checked);
    admissionSelected.forEach((checkbox) => {
      if (checkbox.checked === true) {
        admissionIds.push(checkbox.value);
      }
    });
    if (downloadCsv) {
      const downloadCsvUrl = new URL(downloadCsv.href);
      downloadCsvUrl.searchParams.set('admission_ids', admissionIds);
      downloadCsv.href = downloadCsvUrl;
    }
  }

  /* eslint-disable class-methods-use-this */
  updateFormat (event) {
    const downloadCsv = document.getElementById('downloadAdmissions');
    const format = event.target.value;
    const downloadUrl = new URL(downloadCsv.href);
    downloadUrl.searchParams.set('format', format);
    downloadCsv.href = downloadUrl.toString();
  }
  /* eslint-enable class-methods-use-this */
}
